export default function () {

    // Close search
    $('.close-search').on('click', function(e) {
        const form = $(this).closest('.header-search').find('form');

        $(this).toggleGlobalSearch(false);

        if (!form.length) {
            return;
        }

        form.trigger('reset');
    });
}
